// 数据标准管理
import standardManageRouter from './routes/standardManage'
// 系统管理
import systemAdministration from './routes/systemAdministration'
// 信息对象解析
import encodeRule from './routes/encodeRule'
// 数据采集管理
import dataCollectionManage from './routes/dataCollectionManage'
// 时序数据采集
import timingDataCollection from './routes/timingDataCollection'
// 时序数据采集
import dataValidationReport from './routes/dataValidationReport'
// 数据质量管理
import dataQualityManage from './routes/dataQualityManage'
// 数据资产管理
import dataAssetManagement from './routes/dataAssetManagement'
// 数据服务管理
import dataServicesRouter from './routes/dataServices'
// 数据应用
import dataVisualization from './routes/dataVisualization'
// 元数据管理
import metadataManage from './routes/metadataManage'
// 主数据管理
import masterDataManagement from './routes/masterDataManagement'
// 数据安全保护
import desensitizationRules from './routes/desensitizationRules'
// 数据模型
import dataModel from './routes/dataModel'
// 数据指标
import dataMetrics from './routes/dataMetrics'
// 首页
import home from './routes/home'
// 贴源层管理
import stickerSourceManagement from './routes/stickerSourceManagement'
// 在线填报
import onlineFilling from './routes/onlineFilling'
// 数据审批
import dataApprovalRoute from './routes/dataApproval'
// 模型文档管理
import digitalHandover from './routes/digitalHandover'
// 模型业务
import modelBussiness from './routes/modelBussiness'

const routes = [
  ...digitalHandover,
  ...home,
  ...standardManageRouter,
  ...systemAdministration,
  ...encodeRule,
  ...dataCollectionManage,
  ...timingDataCollection,
  ...dataValidationReport,
  ...dataQualityManage,
  ...dataAssetManagement,
  ...dataServicesRouter,
  ...dataVisualization,
  ...metadataManage,
  ...desensitizationRules,
  ...masterDataManagement,
  ...dataModel,
  ...dataMetrics,
  ...stickerSourceManagement,
  ...onlineFilling,
  ...dataApprovalRoute,
  ...modelBussiness,
]

export default [
  {
    path: '/legacy-resource',
    name: 'legacy-resource',
    id: '9e1dc049-6314-47c8-8476-73c92166d4f4',
    meta: { title: 'Resource' },
    children: routes,
  },
  {
    id: '90afbcb6-9563-419f-b5ba-4d52db43d52f',
    path: '/fullscreen/model-doc-view',
    name: 'model-doc-view',
    layout: 'fullscreen',
    meta: {
      title: '模型文档浏览',
      hidden: true,
    },
    children: [
      {
        id: '12d144c6-d8f4-4c66-8f6c-988a23a39583',
        path: 'index',
        name: 'index',
        component: (resolve) => {
          require(['./views/documentBrowse'], resolve)
        },
        meta: {
          title: '模型文档浏览',
          tabnab: false,
        },
      },
    ],
  },
  {
    id: '7a5d7b53-49de-4a1d-87de-17c9f7f389f4',
    path: '/fullscreen/model-doc-view-vk',
    name: 'model-doc-view-vk',
    layout: 'fullscreen',
    meta: {
      title: '模型文档浏览',
      hidden: true,
    },
    children: [
      {
        id: '92c673fe-0ccf-4946-a94e-441ec62bf296',
        path: 'index',
        name: 'index',
        component: (resolve) => {
          require(['./views/documentBrowseVk'], resolve)
        },
        meta: {
          title: '模型文档浏览',
          tabnab: false,
        },
      },
    ],
  },
]
